<template>
  <div>
    <el-select
      filterable
      clearable
      v-model="ModuleSelected"
      placeholder="Seleccione el Modulo Asociado al Problema"
      :loading="isLoading"
      loading-text="Cargando Datos"
      no-data-text="Debe seleccionar un módulo"
      size="small"
      style="width: 100%"
      @change="OnModuleSelected"
    >
      <el-option
        v-for="item in ModuleOptions"
        :key="item.Id"
        :label="item.Title"
        :value="item.Id"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "ModuleSelector",
  props: {
    moduleId: {
      type: [Number, String],
      default: "",
      reuired: false
    }
  },
  data() {
    return {
      // ModuleSelected: "",
      ModuleOptions: [],
      isLoading: false
    };
  },
  computed: {
    ModuleSelected() {
      return this.moduleId;
    }
  },
  mounted() {
    this.GetModulesData();
  },

  methods: {
    OnModuleSelected(ModuleId) {
      this.$emit("ModuleSelected", ModuleId);
    },
    async GetModulesData() {
      this.isLoading = true;
      await this.$http
        .get("/api/InternalServiceRequest/GetModulesForNewRequest")
        .then((resp) => {
          this.ModuleOptions = resp.data;
        })
        .catch((err) => {
          console.error(err);
          this.$message.error(
            "Ha ocurrido un error al cargar los datos de los modulos."
          );
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style scoped></style>
